module.exports = __webpack_public_path__ + "img/04-thumb.5878c992.jpg";